export default __webpack_public_path__ + "static/media/est-saogabriel.e686d67f.png";